'use client';

import {
  Stack,
  TextField,
  Typography,
  type TextFieldProps,
} from '@mui/material';

import { InputErrorIcon } from '@/components/form/validation/inputErrorIcon';

export const errors: Record<string, string> = {
  EON_ACCOUNT_NOT_FOUND: 'Eon account not found for domain',
  PROJECTS_ERROR: 'Failed to get projects',
  JWT_SECRET_MISSING: 'JWT is missing',
  JWT_SIGNING_ERROR: 'Failed to sign jwt',
  AUTH_HEADER_ERROR: 'Failed to set auth header',
};

export function DomainInput({
  errorType,
  slotProps: slotPropsProp,
  ...props
}: TextFieldProps & { errorType?: string }) {
  return (
    <div className='relative'>
      <TextField
        error={errorType === 'EON_ACCOUNT_NOT_FOUND'}
        size='medium'
        placeholder='your-company'
        slotProps={{
          ...slotPropsProp,
          htmlInput: {
            ...slotPropsProp?.htmlInput,
            id: 'login-domain',
            style: { height: '36px', paddingRight: 130 },
          },
        }}
        {...props}
      />
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          gap: '4px',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          right: '12px',
        }}
      >
        {errorType === 'EON_ACCOUNT_NOT_FOUND' && (
          <InputErrorIcon errorMessage={errors[errorType]} />
        )}
        <Typography>.console.eon.io</Typography>
      </Stack>
    </div>
  );
}
